<div [kalLoading]="loading">
    <div kalDialogContent [formGroup]="form" class="docBankListDialog">

        <div class="docBankListDialog__tools gup-C-flexGroup -row -alignCenter -justifyStart gup-o-list"
             *ngIf="shouldDisplayLocalFile else documentListTemplate">

            <app-document-bank-create-document formControlName="localFile">
            </app-document-bank-create-document>

        </div>

        <ng-template #documentListTemplate>

            <app-shared-icon-button (click)="toggleAddLocalFile()">
                Importer un document depuis l'ordinateur
            </app-shared-icon-button>

            <app-document-bank-list [disabledFilters]="data.disabledFilters"
                                    formControlName="fileFromList">
            </app-document-bank-list>

        </ng-template>

    </div>

    <div kalDialogFooter *ngIf="!isOpenedFilters">

        <div class="gup-C-validationArea gup-O-list">

            <div class="gup-O-list__item">

                <kal-button kalTheme="primary"
                            [disabled]="form.invalid || loading"
                            (click)="submit()">
                    Ajouter
                </kal-button>

            </div>

            <div class="gup-O-list__item">

                <kal-button kalTheme="secondary"
                            (click)="close()">
                    Annuler
                </kal-button>

            </div>

        </div>

    </div>

</div>
